import { bambiApi } from 'src/common/external/bambi-api/bambiApi';

// Trip-specific endpoint overrides live in tripsApi.ts so that tripsApi can be
// lazy-loaded without pulling in bambiApi. Overrides for other split APIs that
// still need to apply here should be moved out similarly as those APIs become
// lazy-load candidates.

// https://redux-toolkit.js.org/rtk-query/api/created-api/code-splitting#enhanceendpoints
// TODO: use this to remove as much of post-process.js as possible
const enhancedBambiApi = bambiApi.enhanceEndpoints({
  // 'trips' lives on tripsApi and 'assignments' on assignmentsApi; declare here
  // so the cross-file invalidations below (e.g. dispatchRetrieve) can reference them.
  addTagTypes: ['trips', 'assignments', 'preferred-drivers'],
  endpoints: {
    dispatchRetrieve: {
      providesTags: ['dispatch', 'trips', 'assignments'],
    },
    organizationSettingsPartialUpdate: {
      invalidatesTags: ['organizations', 'user'],
    },
    passengersDestroy: {
      invalidatesTags: ['billing', 'dispatch', 'passengers', 'trips'],
    },
    passengersUndeleteCreate: {
      invalidatesTags: ['billing', 'dispatch', 'passengers', 'trips'],
    },
    passengersCreate: {
      invalidatesTags: ['dispatch', 'passengers', 'tags'],
    },
    passengersPartialUpdate: {
      invalidatesTags: ['dispatch', 'passengers', 'tags'],
    },
    invoicesInvoicesCreate: {
      invalidatesTags: ['billing', 'invoices'],
    },
    tripTagsCreate: {
      invalidatesTags: ['dispatch', 'trips', 'tags'],
    },
    tripTagsDestroy: {
      invalidatesTags: ['dispatch', 'trips', 'tags'],
    },
    driverTagsList: {
      providesTags: ['drivers', 'tags'],
    },
    driverTagsCreate: {
      invalidatesTags: ['dispatch', 'drivers', 'tags', 'trips'],
    },
    driverTagsDestroy: {
      invalidatesTags: ['dispatch', 'drivers', 'tags', 'trips'],
    },
    vehicleTagsList: {
      providesTags: ['vehicles', 'tags'],
    },
    vehicleTagsCreate: {
      invalidatesTags: ['dispatch', 'vehicles', 'tags', 'trips'],
    },
    vehicleTagsDestroy: {
      invalidatesTags: ['dispatch', 'vehicles', 'tags', 'trips'],
    },
    passengerTagsList: {
      providesTags: ['passengers', 'tags'],
    },
    passengerTagsCreate: {
      invalidatesTags: ['dispatch', 'passengers', 'tags'],
    },
    passengerTagsDestroy: {
      invalidatesTags: ['dispatch', 'passengers', 'tags'],
    },
    tilledPaymentMethodVerifyCreate: {
      invalidatesTags: ['tilled'],
    },
    invoicesPaymentLinkCreate: {
      // Don't invalidate the invoices list because it causes a refresh bug in
      // the payment modal, which resets the payer list. At the time of writing
      // this, we don't rely on creating a payment link to refresh any data.
      invalidatesTags: [],
    },
    invoicesPayersList: {
      // Override the tag on this to align it to payers instead of invoices.
      // There currently isnt anything in the invoices tag that should cause the
      // payers list to refresh. This endpoint is a filtered list of payers by
      // those payers on an invoice.
      providesTags: ['payers'],
    },
    // invalidating members here to trigger the member list refresh for the
    // profile create workflow
    attendantsCreate: {
      invalidatesTags: ['attendants', 'members'],
    },
    driversCreate: {
      invalidatesTags: ['drivers', 'members'],
    },
    passengersPreferredDriversList: {
      providesTags: ['preferred-drivers'],
    },
    passengersPreferredDriversRetrieve: {
      providesTags: ['preferred-drivers'],
    },
    passengersPreferredDriversCreate: {
      invalidatesTags: ['preferred-drivers'],
    },
    passengersPreferredDriversPartialUpdate: {
      invalidatesTags: ['preferred-drivers'],
    },
    passengersPreferredDriversDestroy: {
      invalidatesTags: ['preferred-drivers'],
    },
  },
});

export { enhancedBambiApi };
